import { useState, useEffect } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

const CalendarContent = ({
  calendarRef,
  isEditing,
  events,
  handleDateClick,
  handleEventClick,
  handleViewChange,
  dayMaxEvents,
}) => {
  const [viewType, setViewType] = useState('dayGridMonth');

  const onDatesSet = (info) => {
    handleViewChange(info);
    setViewType(info.view.type);
  };

  return (
    <div className="calendar-container">
      <div className="calendar-wrapper" style={{ padding: '16px' }}>
        <FullCalendar
          ref={calendarRef}
          plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          timeZone="local"
          headerToolbar={
            viewType !== 'dayGridMonth'
              ? { left: 'backToMonth prev,next', center: 'title', right: 'dayGridMonth,timeGridWeek,timeGridDay' }
              : { left: 'prev,next', center: 'title', right: '' }
          }
          customButtons={{
            backToMonth: {
              text: '◀ 월',
              click: () => calendarRef.current?.getApi().changeView('dayGridMonth'),
            },
          }}
          events={events}
          dateClick={handleDateClick}
          eventClick={handleEventClick}
          viewDidMount={onDatesSet}
          datesSet={onDatesSet}
          height="auto"
          locale="ko"
          buttonText={{ month: '월', week: '주', day: '일' }}
          slotMinTime="06:00:00"
          slotMaxTime="24:00:00"
          allDaySlot={false}
          nowIndicator={true}
          dayMaxEvents={dayMaxEvents ?? 3}
          moreLinkText={(num) => `+${num}개`}
          eventDisplay="block"
          displayEventTime={false}
          navLinks={true}
          navLinkDayClick={(date) =>
            calendarRef.current?.getApi().changeView('timeGridDay', date)
          }
        />
      </div>
    </div>
  );
};

export default CalendarContent;
